import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';

import { formatAmountValue } from 'helpers/helpers';

import { SimpleBucket } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces'; //AccountEditPlan
import useStyles from 'components/Bucket/styles'; //
import { colors } from 'components/Bucket/Bucket';
import { Currency } from 'enums';

interface OwnProps {
  activated?: boolean;
  currency?: Currency;
  portfolioOnly?: boolean;
}

type Props = SimpleBucket & OwnProps;

const DevelopmentTab: React.FC<Props> = (props) => {
  const { title, type, balance, currency , activated, active} = props;

  const { t } = useTranslation();
  const bgColor = colors[type] || 'transparent';
  const classes = useStyles({ ...props, simple: true, bgColor });

  return (
    <Card className={classes.bucket}>
      <div className={classes.header}>
        <div className={classes.headerBg} />
        <Box position="relative">
          <Typography variant="h3" className={classes.portfolioTitle}>
            {t(`${title}`)} {!active && t('general_inactive')}
          </Typography>
          {!activated && currency && (
            <Typography variant="h3" className={classes.portfolioValue}>
              {formatAmountValue(balance.value, currency)}
            </Typography>
          )}
        </Box>
      </div>
    </Card>
  );
};

export default DevelopmentTab;
